<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Asignar Usuarios",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            filtro:{
                colegio:''
            },
            colegios:[],
            users:[],
            cargos:[],
            instrumentos:[],
            cargo:'',
            instrumento:''
        };
    },
    methods:{
        actualizar(){
            if (this.user.rol_id==1) {
                axios.get('/api/get_colegios').then(res=>{
                    this.colegios = res.data.colegios;
                });
            }
            else if (this.user.rol_id==2) {
                this.filtro.colegio=this.user.colegio_id;
                this.buscar();
            }
            axios.get('/api/get_cargos').then(res=>{
                this.cargos = res.data.cargos;
            });
            axios.get('/api/get_instrumentos').then(res=>{
                this.instrumentos = res.data.instrumentos;
            });
        },
        buscar(){
            axios.get('/api/get_personas_colegio/'+this.filtro.colegio).then(res=>{
                this.users = res.data.users;
            });
        },
        cambio_instrumento(usuario){
            let payload={
                usuario:usuario,
                colegio_id:this.filtro.colegio
            }
            axios.post('/api/cambio_instrumento', payload).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    //console.log(res.data.mensaje)
                    this.actualizar();
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                }else{
                    //this.$toasted.error(res.data.mensaje);
                    //console.log(res.data.mensaje)
                    Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                }
            });
        },
        cambio_cargo(usuario){
            let payload={
                usuario:usuario,
                colegio_id:this.filtro.colegio
            }
            axios.post('/api/cambio_cargo', payload).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    console.log(res.data.mensaje)
                    this.actualizar();
                    Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                }else{
                    //this.$toasted.error(res.data.mensaje);
                    console.log(res.data.mensaje)
                    Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: res.data.mensaje,
                    showConfirmButton: false,
                    timer: 1500
                    })
                }
            });
        }
    },
    created() {
        this.actualizar();
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right ml-2" variant="primary" href="/app/agregar/usuarios">Usuarios</b-button>
                            </div>
                        </div>
                        <div class="card p-3 mt-2 bg-soft-primary" v-if="user.rol_id==1">
                            <div class="row">
                                <div class="offset-md-2 col-md-6">
                                    <div class="form-group row">
                                        <label class="col-md-3 pt-1 font-size-16 text-right">Colegio :</label>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="filtro.colegio" @change="buscar()">
                                                <option disabled value="">Seleccione colegio</option>
                                                <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}} ({{colegio.comuna_nombre}} - {{colegio.region_nombre}})</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <b-button variant="primary" block @click="buscar()">Buscar</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Nombre </th>
                                                <th>Rut</th>
                                                <th>Cargo</th>
                                                <th>Instrumento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(usuario,index ) in users" :key="index">
                                                <th>{{index+1}}</th>
                                                <td>{{usuario.nombre}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}}</td>
                                                <td>{{usuario.rut}}-{{usuario.rut_dv}}</td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.cargo_id"  @change="cambio_cargo(usuario)">
                                                        <option disabled value="">Seleccione cargo</option>
                                                        <option value="OTRO">OTRO</option>
                                                        <option v-for="cargo in cargos" :key="cargo.id" :value="cargo.id">{{cargo.nombre}}</option>
                                                    </select>
                                                </td>
                                                <td>
                                                    <select class="custom-select" v-model="usuario.instrumento_id" @change="cambio_instrumento(usuario)">
                                                        <option disabled value="">Seleccione instrumento</option>
                                                        <option :value="null">No aplica</option>
                                                        <option v-for="instrumento in instrumentos" :key="instrumento.id" :value="instrumento.id">{{instrumento.nombre}}</option>
                                                    </select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>